import Layout from './components/layout';
// import Details from './components/Details';
import ContractDetailsDailog from './components/ContractDetailsDailog';

export default {
	Layout,
	ContractDetailsDailog
}